// src/questions.js
const Questions = Object.freeze({
    SPM1: "Går du personligt ind for omskæring af raske drenge?",
    SPM2: "Går du ind for en 18 års aldersgrænse for omskæring af raske drenge?",
    SPM3: "Er dit parti på nuværende tidspunkt fritstillet i spørgsmålet om omskæring?",
    SPM4: "Vil du stemme imod partilinjen, hvis spørgsmålet bliver aktuelt?",
    SPM5: "Eventuel kommentar",
});

export default Questions;
